/* Conflict notice banner (GH #1912, docs/ux/2026-10-24-conflict-notice-ux.md): above the field, never over it */
.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border-radius: var(--tuna-shape-borderRadius);
  background-color: color-mix(in oklch, var(--tuna-palette-warning-light) 15%, transparent);
  color: var(--tuna-feedback-warning-text);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: var(--tuna-typography-body2-lineHeight);
}

.lead,
.subline,
.failed {
  margin: 0;
}

.list {
  margin: 0;
  padding-left: var(--tuna-spacing-3);
}

.failed {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  color: var(--tuna-feedback-error-text);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
}

.actions button {
  min-height: 44px;
}

/* "Your changes are saved." is announced, not shown: the banner closing is the visible change */
.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

/* The inline banner's place in its panel, without a box of its own (GH #2713) */
.contents {
  display: contents;
}
